import { defineStore } from 'pinia';
import { fetchData } from '@/services/graphql';
import { listHospitals } from '@/graphql/hospitals.graphql';

export const useHospitalsStore = defineStore('hospitals', {
    state: () => ({
        hospitals: [],
        isLoading: false,
        error: null,
    }),
    actions: {
        getHospital( hospitalId ) {
            return this.hospitals.find((hospital) => hospital.hospital_id === hospitalId);
        },
        async fetchHospitals() {
            this.isLoading = true;
            this.error = null;

            try {
                this.hospitals = await fetchData(listHospitals, {});

            } catch (error) {
                console.error('Error fetching hospitals:', error);
                this.error = error.message || 'Failed to load hospitals.';
            } finally {
                this.isLoading = false;
            }
        },
    },
});
